var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { CaseApplyRecordService } from '~/services/domain-service/case-apply-record.service';
import { OutsourceRecycleService } from '~/services/domain-service/outsource-recycle-manage.service';
var ApplyFlow = /** @class */ (function (_super) {
    __extends(ApplyFlow, _super);
    function ApplyFlow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // apply实体
        _this.applyModel = {
            caseIds: [],
            turnGoal: '',
            applyDescription: '',
            confirm: 1,
        };
        _this.applyRules = {
            turnGoal: [
                { required: true, message: '请选择流转去向', trigger: 'change' },
            ],
            applyDescription: [
                { required: true, message: '请输入申请说明', trigger: 'blur' },
            ],
        };
        return _this;
    }
    ApplyFlow.prototype.refreshList = function () { };
    ApplyFlow.prototype.close = function () { };
    //将选择的id放到数组
    ApplyFlow.prototype.getSelectionListArray = function () {
        var _this = this;
        if (this.selectionList instanceof Array) {
            this.applyModel.caseIds = [];
            this.selectionList.map(function (value) {
                _this.applyModel.caseIds.push(value.id);
            });
        }
    };
    ApplyFlow.prototype.commit = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (valid) {
            if (!valid) {
                return;
            }
            _this.getSelectionListArray();
            //默认加载列表
            _this.caseApplyRecordService.applyCirculationCase(_this.applyModel).subscribe(function (data) {
                _this.$message.success('操作成功!');
                _this.refreshList();
                _this.refresh();
                _this.close();
            });
        });
    };
    ApplyFlow.prototype.refresh = function () {
        var form = this.$refs.form;
        form.resetFields();
    };
    __decorate([
        Dependencies(OutsourceRecycleService)
    ], ApplyFlow.prototype, "outsourceRecycleService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], ApplyFlow.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop()
    ], ApplyFlow.prototype, "selectionList", void 0);
    __decorate([
        Prop({ type: String })
    ], ApplyFlow.prototype, "fromChannel", void 0);
    __decorate([
        Getter
    ], ApplyFlow.prototype, "isSupperAdmin", void 0);
    __decorate([
        Emit('refreshList')
    ], ApplyFlow.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], ApplyFlow.prototype, "close", null);
    ApplyFlow = __decorate([
        Component({
            components: {},
        })
    ], ApplyFlow);
    return ApplyFlow;
}(Vue));
export default ApplyFlow;
